import { Component, OnInit, OnDestroy } from "@angular/core";
import {
  NavigationStart,
  Event as NavigationEvent,
  Router,
} from "@angular/router";
import { Subscription } from "rxjs";
import { GlobalService } from "./shared/services/global/global.service";
import { _AES_EncryptionService } from "./core/services/aes-encryption.service"; //  import added

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  standalone: false,
})
export class AppComponent implements OnInit, OnDestroy {
  title = "Flexyear";

  private timeoutId: any;
  private currentLocation = "";
  private routerSub: Subscription;
  private readonly IDLE_TIMEOUT = 25 * 60 * 1000;

  constructor(
    private globalService: GlobalService,
    private router: Router,
    private aes: _AES_EncryptionService,
  ) {}

  ngOnInit(): void {
    this.aes.preload(); //  fire-and-forget — gives crypto-js max head start before RoleGuard runs
    this.removeAppLoader();
    this.trackCurrentRoute();
    this.startIdleWatcher();
  }

  private removeAppLoader(): void {
    const loader = document.getElementById("app-loading");
    if (loader) {
      loader.style.opacity = "0";
      loader.style.transition = "opacity 0.3s ease";
      setTimeout(() => loader.remove(), 300);
    }
  }

  private trackCurrentRoute(): void {
    this.routerSub = this.router.events.subscribe((event: NavigationEvent) => {
      if (event instanceof NavigationStart) {
        this.currentLocation = event.url;
      }
    });
  }

  private startIdleWatcher(): void {
    const resetTimer = () => {
      clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(() => {
        if (!this.currentLocation.includes("/login")) {
          this.globalService.logout();
          window.location.reload();
        }
      }, this.IDLE_TIMEOUT);
    };

    ["mousemove", "keypress", "click", "scroll", "touchstart"].forEach(
      (event) => {
        document.addEventListener(event, resetTimer, { passive: true });
      },
    );

    resetTimer();
  }

  ngOnDestroy(): void {
    clearTimeout(this.timeoutId);
    this.routerSub?.unsubscribe();
  }
}
